export enum KEYFRAME_ANCHOR_TYPE {
    left = 'left',
    right = 'right',
}
